import { MetaFilters, MetaCreateData } from "../types/meta";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:3001";

const getAuthHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem("token")}`,
  "Content-Type": "application/json",
});

export const metaService = {
  getMetas: async (filters?: MetaFilters) => {
    const params = new URLSearchParams();
    if (filters?.name) params.append("name", filters.name);
    if (filters?.lojaId) params.append("lojaId", filters.lojaId.toString());
    if (filters?.tipo) params.append("tipo", filters.tipo);

    const response = await fetch(
      `${API_URL}/metas${params.toString() ? `?${params.toString()}` : ""}`,
      {
        headers: getAuthHeaders(),
      }
    );
    if (!response.ok) {
      const body = await response.json().catch(() => ({}));
      const msg = body?.message;
      const message = Array.isArray(msg)
        ? msg.join(", ")
        : typeof msg === "string"
          ? msg
          : "Erro ao buscar metas";
      throw new Error(message);
    }
    return response.json();
  },

  createMeta: async (data: MetaCreateData) => {
    const response = await fetch(`${API_URL}/metas`, {
      method: "POST",
      headers: getAuthHeaders(),
      body: JSON.stringify(data),
    });
    if (!response.ok) {
      const body = await response.json().catch(() => ({}));
      const msg = body?.message;
      const message = Array.isArray(msg)
        ? msg.join(", ")
        : typeof msg === "string"
          ? msg
          : "Erro ao criar meta";
      throw new Error(message);
    }
    return response.json();
  },

  updateMeta: async (id: number, data: MetaCreateData) => {
    const response = await fetch(`${API_URL}/metas/${id}`, {
      method: "PUT",
      headers: getAuthHeaders(),
      body: JSON.stringify(data),
    });
    if (!response.ok) {
      const body = await response.json().catch(() => ({}));
      const msg = body?.message;
      const message = Array.isArray(msg)
        ? msg.join(", ")
        : typeof msg === "string"
          ? msg
          : "Erro ao atualizar meta";
      throw new Error(message);
    }
    const result = await response.json();
    return result;
  },

  deleteMeta: async (id: number) => {
    const response = await fetch(`${API_URL}/metas/${id}`, {
      method: "DELETE",
      headers: getAuthHeaders(),
    });
    if (!response.ok) throw new Error("Erro ao deletar meta");
    return response.json();
  },
};
